import { render, staticRenderFns } from "./MCopy.vue?vue&type=template&id=4d49d52f&scoped=true"
import script from "./MCopy.vue?vue&type=script&lang=ts"
export * from "./MCopy.vue?vue&type=script&lang=ts"
import style0 from "./MCopy.vue?vue&type=style&index=0&id=4d49d52f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49d52f",
  null
  
)

export default component.exports